import api from '@/shared/api';
import { useMutation } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
export const useChangeCommunicationEmail = () => {
    const intl = useIntl();
    const { mutateAsync, isLoading } = useMutation(values => api.base
        .post('/api/employee/profile/change-email', values)
        .then(res => res.data), {
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
    });
    return { changeCommunicationEmail: mutateAsync, isLoading };
};
